// extracted by mini-css-extract-plugin
export default {"formGroup":"Select_formGroup__JXw65","mandatory":"Select_mandatory__NucKT"};